import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { eur } from "@/lib/api";
import { useI18n } from "@/i18n";
import { AlertTriangle, Info, CircleAlert, ArrowRight } from "lucide-react";

const LIV = {
  bad: { box: "border-rose-200 bg-rose-50 text-rose-900", icon: CircleAlert },
  warn: { box: "border-amber-200 bg-amber-50 text-amber-900", icon: AlertTriangle },
  info: { box: "border-slate-200 bg-slate-50 text-slate-700", icon: Info },
};

export const SituazioneCassa = ({ d }) => {
  const { t } = useI18n();
  const voci = [
    { id: "cashed", l: t("sit.cashed"), v: eur(d.cashed), s: t("sit.cashedSub") },
    { id: "tocollect", l: t("sit.toCollect"), v: eur(d.to_collect), s: t("sit.toCollectSub", { n: d.to_collect_tables }), hot: d.to_collect > 0 },
    { id: "cash", l: t("sit.cashExpected"), v: eur(d.cash_expected), s: t("sit.cashExpectedSub", { v: eur(d.floats_total) }) },
    {
      id: "count",
      l: t("sit.lastCount"),
      v: d.last_count ? eur(d.last_count.difference) : "—",
      s: d.last_count ? t("sit.lastCountSub") : t("sit.noCount"),
      hot: !!d.last_count && Math.abs(d.last_count.difference) >= 1,
    },
  ];

  return (
    <div className="space-y-3" data-testid="situazione-adesso">
      <Card className="overflow-hidden p-0">
        <div className="grid grid-cols-2 divide-slate-200 sm:grid-cols-4 sm:divide-x">
          {voci.map((x) => (
            <div key={x.id} className="p-4" data-testid={`sit-${x.id}`}>
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">{x.l}</p>
              <p className={`font-num mt-2 text-2xl font-bold ${x.hot ? "text-rose-600" : ""}`}>{x.v}</p>
              <p className="mt-0.5 text-[11px] text-slate-500">{x.s}</p>
            </div>
          ))}
        </div>
        {d.per_method?.length > 0 && (
          <div className="flex flex-wrap gap-x-4 gap-y-1 border-t border-slate-200 bg-slate-50 px-4 py-2.5" data-testid="sit-methods">
            {d.per_method.map((m) => (
              <span key={m.method} className="font-num text-[11px] text-slate-600">
                {m.method}: <b>{eur(m.amount)}</b>
              </span>
            ))}
          </div>
        )}
      </Card>

      {d.alerts?.length > 0 && (
        <div className="space-y-2" data-testid="serata-alerts">
          {d.alerts.map((a) => {
            const st = LIV[a.level] || LIV.info;
            return (
              <Link
                key={a.id}
                to={a.to}
                data-testid={`alert-${a.id}`}
                className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 text-sm transition-transform hover:translate-x-0.5 ${st.box}`}
              >
                <st.icon className="h-4 w-4 shrink-0" />
                <span className="min-w-0 flex-1 font-medium">{a.text}</span>
                <ArrowRight className="h-3.5 w-3.5 shrink-0 opacity-60" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};
